import { createVolumeAutocompleteFilter } from './common/createVolumeAutocompleteFilter';

export default createVolumeAutocompleteFilter({
  field: 'instanceId',
  groupLabel: 'Instance ID',
  mustTypeFirstMessage: 'Start typing instance id',
  defaultQuery: 'i-',
  tagVariant: 'instance',
  logPrefix: '[InstanceFilter]',
});
